import useWidth from '../../../../../../../components/Hooks/useWidth';
import { CombinationLineProps } from '../../types/combinationLine.types';
import CombinationLineDesktop from './CombinationLineDesktop';
import CombinationLineMobile from './CombinationLineMobile';

const CombinationLine = (props: CombinationLineProps) => {
  const { mobileWidth } = useWidth();

  return mobileWidth ? <CombinationLineMobile {...props} /> : <CombinationLineDesktop {...props} />;
};

export default CombinationLine;
